import ArrowIconClosed from './component.jsx'
export default ArrowIconClosed
